/**
 * E-11 / AC-13: share PostHog anonymous id across mivo.digital ↔ app.mivo.digital.
 * Acceptance remains production smoke (T6.5) — config alone does not pass.
 */
export function shouldUseCrossSubdomainCookie(hostname: string): boolean {
  const host = hostname.trim().toLowerCase();
  if (host === "mivo.digital") {
    return true;
  }

  if (host.endsWith(".mivo.digital")) {
    return true;
  }

  return false;
}
